import { IonModal, IonButton, IonLabel, IonSelect, IonSelectOption,IonRow,IonCol,IonHeader,IonTitle,IonIcon} from "@ionic/react";
import { checkmarkCircleOutline, closeCircleOutline } from "ionicons/icons";
import React from "react";

interface LogsModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    selectedPeriod: string;
    setSelectedPeriod: (value: string) => void;
    errorMessage?: string;
}

const LogsModal: React.FC<LogsModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    selectedPeriod,
    setSelectedPeriod,
    errorMessage
}) => {
    return (
        <IonModal
            isOpen={isOpen}
            onWillDismiss={onClose}
            onDidDismiss={onClose}
            cssClass="logs-modal"
        >
            <IonHeader className="logs-modal-header">
                <IonTitle className="logs-modal-title">Eliminar historial de Logs</IonTitle>
            </IonHeader>
            <IonRow className="logs-modal-seleccion">
                <IonLabel className="logs-filtro-label">Seleccione el período que desee eliminar</IonLabel>
                <IonSelect
                    interface="popover"
                    className="logs-filtro-select"
                    placeholder="Seleccione período"
                    value={selectedPeriod}
                    onIonChange={(e) => setSelectedPeriod(e.detail.value)}>
                    <IonSelectOption value="TRIMESTRAL">TRIMESTRAL</IonSelectOption>
                    <IonSelectOption value="SEMESTRAL">SEMESTRAL</IonSelectOption>
                    <IonSelectOption value="ANUAL">ANUAL</IonSelectOption>
                </IonSelect>
            </IonRow>

            {errorMessage && (
                <IonLabel className="logs-modal-error">
                    {errorMessage}
                </IonLabel>
            )}
            <IonRow className="ion-justify-content-center ion-align-items-center ion-margin-top">
                <IonCol size="auto">
                    <IonButton fill="clear" className="modal-ion-button" onClick={onConfirm}>
                        <IonIcon icon={checkmarkCircleOutline} color="success" className="modal-ion-icon-button" />
                    </IonButton>
                </IonCol>
                <IonCol size="auto">
                    <IonButton fill="clear" className="modal-ion-button" onClick={onClose}>
                        <IonIcon icon={closeCircleOutline} color="danger" className="modal-ion-icon-button" />
                    </IonButton>
                </IonCol>
            </IonRow>
        </IonModal>
    );
};

export default LogsModal;